import React, { ReactNode, useEffect, useRef } from "react";
import styles from "./SideModal.module.scss";
import classNames from "classnames";
import { ArrowDownIcon, CloseWhiteIcon } from "Assets";

type Props = {
  /** Use null as initial state to avoid animation of first render */
  isOpen: boolean | null;
  onClose: () => void;
  className?: string;
  headerClassName?: string;
  headerChildren?: ReactNode;
  actionButtons?: ReactNode;
  title?: ReactNode;
  extraConditionToOutsideClick?: boolean;
  children: ReactNode;
  fixed?: boolean;
  animationType?: "horizontal" | "vertical";
};

export const SideModal = ({
  isOpen,
  onClose,
  className,
  headerClassName,
  children,
  headerChildren,
  title,
  actionButtons,
  fixed,
  extraConditionToOutsideClick = false,
  animationType = "horizontal",
}: Props) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (fixed) {
      if (isOpen) document.body.style.overflow = "hidden";
      else document.body.style.overflow = "auto";
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen !== null &&
        modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        extraConditionToOutsideClick === false
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose, isOpen, fixed, extraConditionToOutsideClick]);

  return (
    <>
      {fixed && isOpen && <div className={styles.overlay} />}
      <div
        ref={modalRef}
        className={classNames(
          styles.sideModal,
          className,
          isOpen === null
            ? null
            : isOpen
              ? animationType === "horizontal"
                ? styles.sideModal_open
                : styles.sideModal_openY
              : animationType === "horizontal"
                ? styles.sideModal_closed
                : styles.sideModal_closedY
        )}
      >
        <div className={classNames(styles.sideModal__header, headerClassName)}>
          <div className={styles.sideModal__headerTitle} onClick={onClose}>
            <p>{title}</p>
            <div className={styles.sideModal__actions}>
              {!!actionButtons && actionButtons}
              {animationType === "horizontal" ? (
                <CloseWhiteIcon
                  className={styles.sideModal__closeBtn}
                  width={25}
                  height={25}
                />
              ) : (
                <ArrowDownIcon
                  className={styles.sideModal__closeBtnDown}
                  width={25}
                  height={25}
                />
              )}
            </div>
          </div>
          {!!headerChildren && headerChildren}
        </div>
        <div className={styles.sideModal__content}>{children}</div>
      </div>
    </>
  );
};
